import { $themeBreakpoints } from '@themeConfig'

export default {
  namespaced: true,
  state: {
    windowWidth: 0,
    shallShowOverlay: false,
    overlayText: 'Loading...',
    overlayType: null,
    overlayVariant: 'primary',
    sidebar: false,
  },
  getters: {
    currentBreakPoint: state => {
      const { windowWidth } = state
      if (windowWidth >= $themeBreakpoints.xl) return 'xl'
      if (windowWidth >= $themeBreakpoints.lg) return 'lg'
      if (windowWidth >= $themeBreakpoints.md) return 'md'
      if (windowWidth >= $themeBreakpoints.sm) return 'sm'
      return 'xs'
    },
    GET_SIDEBAR_STATUS: state => state.sidebar,
  },
  mutations: {
    UPDATE_WINDOW_WIDTH(state, val) {
      state.windowWidth = val
    },
    TOGGLE_OVERLAY(state, val) {
      state.shallShowOverlay = val !== undefined && val !== null
      if (val) {
        state.overlayText = val.text
        state.overlayVariant = val.color
      }
    },
    TOGGLE_SIDEBAR(state, val) {
      state.sidebar = val
    },
  },
  actions: {},
}
